// How far a listing's "vs Markt" figure should be trusted, mirroring
// invest_config.spread_confidence on the Python side.
//
// The threshold lived as a bare 0.5 repeated in three places across two pages
// while every other threshold in this feature (MV_SPREAD_FULL/_NONE/_WIDE,
// MV_CROSSCHECK_PCT) got a name.
export const MV_CONFIDENCE_MUTE = 0.5;

// null/undefined means the dispersion is UNKNOWN — the p25/p75 series has not
// accrued for this market yet, or the baseline came from the single-run batch
// median. Unknown is not the same as untrustworthy: leave those rendered as
// they always were rather than implying a measurement nobody made.
export const isLowConfidence = (l) =>
  l?.mv_confidence != null && l.mv_confidence < MV_CONFIDENCE_MUTE;
